import React from 'react';
import { useDispatch } from 'react-redux';
import { history } from '../../utils/variables';
import { firstBoot } from '../../redux/actions';
import header from '../../assets/images/header.png';
import logo from '../../assets/images/favicons/72.png';
import loginFooter from '../../assets/images/loginFooter.png';

const platform = navigator.userAgent.match(/iPad | iphone/i) ? 'IOS' : 'android';

export default function Tutorial() {

    const dispatch = useDispatch();

    function setRoute() {
        dispatch(firstBoot(true));
        history.replace('/')
    }

    return (
        <div className='tutorial'>
            <img src={header} alt='header' className='headerImage' />
            <div className='content'>
                <div className='text-center'>
                    <img src={logo} alt='favIcon' />
                    <p>همراه بیمه خلیج فارس</p>
                </div>
                {
                    platform === 'IOS' ?
                        <>
                            <p className='mt20'>1. ابتدا روی دکمه <i className='fas fa-long-arrow-alt-up' /> در قسمت بالای مرورگر خود کلیک کنید. </p>
                            <p className='mt10'>2. گزینه <i className='fas fa-plus-square' /> (Add To Home screen) را انتخاب نمایید.</p>
                        </> :
                        <>
                            <p className='mt20'>1. ابتدا روی دکمه <i className='fas fa-ellipsis-v' /> در قسمت بالا سمت راست مرورگر خود کلیک کنید. </p>
                            <p className='mt10'>2. گزینه Add To Home screen را انتخاب نمایید.</p>
                        </>
                }
                <p className='mt10'>3. در پنجره باز شده دکمه Add را انتخاب نمایید.</p>
                <p className='mt10'>4. اپلیکیشن همراه بیمه به لیست برنامه های شما اضافه شد.</p>
                <button className='btn btn-green btn-block btn-circle mt20' onClick={setRoute}>متوجه شدم</button>
            </div>
            <img src={loginFooter} alt='footer' className='headerImage' />
        </div>
    )
}
